import { normalizeReferencedVariable } from "../../../../../src/shared/schemas/PluginSchema";

export const EDITABLE_VARIABLE_ORDER = [
  "preceding_text",
  "following_text",
  "highlighted_text",
  "previous_document_text",
  "user_text_input",
];

export const DOCUMENT_VARIABLE_SETTINGS = {
  highlighted_text: {
    title: "Selected Text",
    description:
      "Specify how many words are required to be selected when using this plugin.",
    minWords: 0,
    minWordsHelper: "Show an error if the selected text is shorter than this",
    maxWords: 2000,
    maxWordsHelper: "Show an error if the selected text is longer than this",
  },
  preceding_text: {
    title: "Preceding Text",
    description:
      "Specify how many words the plugin will look back from the cursor.",
    minWords: 0,
    minWordsHelper: "Show an error if the preceding text is shorter than this",
    maxWords: 500,
    maxWordsHelper: "Sudowrite will read up to this amount of preceding text before stopping",
  },
  following_text: {
    title: "Following Text",
    description:
      "Specify how many words the plugin will look forward from the cursor.",
    minWords: 0,
    minWordsHelper: "Show an error if the following text is shorter than this",
    maxWords: 500,
    maxWordsHelper: "Sudowrite will read up to this amount of following text before stopping",
  },
  previous_document_text: {
    title: "Previous Document Text",
    description:
      "Specify how many words the plugin will look back at in the chain of previous documents linked to the current document when this plugin is used. This can include multiple documents in the chain.",
    minWords: 0,
    minWordsHelper: "Show an error if previous document text is shorter than this",
    maxWords: 2000,
    maxWordsHelper:
      "Sudowrite will read up to this amount of text from previous documents before stopping",
  },
  user_text_input: {
    title: "User Instructions",
    description: "When someone uses your plugin, we'll ask them for additional instructions.",
    instructionsHelper:
      'Tell users what to put in. For example, if your plugin generates series outlines, you might ask "How many books do you want in your series?"',
    instructionsPlaceholder: "Give instructions",
    minWords: 0,
    minWordsHelper: "Increase this if your plugin requires people to give instructions.",
    maxWords: 2000,
    maxWordsHelper:
      "Increase this if you want to let people give very long instructions. Decrease it for smaller context windows.",
  },
};

const VARIABLE_ICON_MAP = {
  user_text_input: "plugin.svg",
};

export const getVariableIconPath = (variableName) =>
  VARIABLE_ICON_MAP[variableName] || "document.svg";

export const getDefaultDocumentInputOutput = (source) => {
  const config = DOCUMENT_VARIABLE_SETTINGS[source];
  if (!config) return null;

  return {
    source,
    target: source,
    minWords: config.minWords,
    maxWords: config.maxWords,
    ...(source === "user_text_input" ? { instructionsText: "" } : {}),
  };
};

export const normalizeLiquidVariableName = normalizeReferencedVariable;
